import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableReportBuilder = Loadable({
  loader: function loader() {
    return import('../ReportBuilder.jsx');
  },
  loading: ComponentLoading
});
export default LoadableReportBuilder;